import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'

//import { FormattedMessage } from 'react-intl'
import MasterData from '../../data/MasterData'

class SingleTrainModal extends React.Component {

  static propTypes = {
    lines: PropTypes.array.isRequired,
    trains: PropTypes.array.isRequired,
    nankai_update_date: PropTypes.string,
    nankai_update_time: PropTypes.string,
    koya_update_date: PropTypes.string,
    koya_update_time: PropTypes.string,
    train_kind_name: PropTypes.string, 
    departure_station_name: PropTypes.string, 
    arrival_station_name: PropTypes.string, 
    station_infos: PropTypes.array,
    fetchLines: PropTypes.func.isRequired,
    fetchTrains: PropTypes.func.isRequired,
    closeTrainModal: PropTypes.func.isRequired,
  }

  static contextTypes = {
    intl: PropTypes.object
  }

  async componentDidMount() {
    const { trainNumber, lineName } = this.props.match.params
    const { fetchLines, fetchTrains, fetchSingleTrain, train_kind_name} = this.props
    // いきなりこのURLが開かれても表示できるようにする
    if (this.props.lines.length === 0) {
      await fetchLines()
    }

    const lines_url = `/lines/${lineName}/trains`
    await fetchTrains(lines_url)
    let line_id = MasterData.lineIdByLineName(lineName)
    let train = this.props.trains.find(t => t.train_number === trainNumber && t.line_id === line_id)
    let scheduleTypes = lineName == "nankai" ? this.props.nankai_scheduleTypes : this.props.koya_scheduleTypes
    
    if (MasterData.isShiomibashiTrain(trainNumber)) {
      // 汐見橋線の列車は南海線としてダイヤ情報を取得する
      line_id = 1
      scheduleTypes = this.props.nankai_scheduleTypes
      train = this.props.trains.find(t => t.train_number === trainNumber)
    } 

    await fetchSingleTrain(line_id, scheduleTypes, this.getTrainBaseTime(lineName, train), train.train_number)

    // 画面全体のスクロールを制御する
    document.querySelector('body').classList.add('disable-whole-scroll')
  }

  getTrainBaseTime(lineName, train) {
    let updateTime = lineName == "nankai" ? this.props.nankai_update_time : this.props.koya_update_time
    let [hours, minutes, seconds] = updateTime.split(':')
    let baseTime = new Date()
    baseTime.setHours(hours, minutes - train.delay, seconds)
    return ('0' + baseTime.getHours()).slice(-2) + ':' + ('0' + baseTime.getMinutes()).slice(-2) + ':' + ('0' + baseTime.getSeconds()).slice(-2)
  }

  componentWillUnmount() {
    this.props.closeTrainModal()

    // 画面全体のスクロール制御を解除
    document.querySelector('body').classList.remove('disable-whole-scroll')
  }

  getTrainPositionPath(stationId) {
    return MasterData.isOnNankaiLine(stationId) ? `/lines/nankai/trains` : `/lines/koya/trains`
  }

  closeModalLink(lineName, trainNumber) {
    return `/lines/${lineName}/trains?showTrainOperationInfo=false#train${trainNumber}`
  }

  closeModal(lineName, trainNumber) {
    this.props.history.push(this.closeModalLink(lineName, trainNumber))
  }

  // ヘッダー
  renderHeader() {
    const { lineName, trainNumber } = this.props.match.params

    return (
      <div className="c-Modal-header">
        <p className="c-Modal-headerTitle">列車情報</p>
        <Link to={this.closeModalLink(lineName, trainNumber)}>
          <div className="c-Modal-headerClose"></div>
        </Link>
      </div>
    )
  }

  // 種別、両数、行き先、現在値などの表示
  renderTrainBody(train) {
    const { departure_station_name, arrival_station_name, station_infos } = this.props
    const { lineName } = this.props.match.params
    var arrival = ""

    if (station_infos) {
      if (station_infos.length == 0) {
        arrival = "is-show"
      }
    }

    var kind = ""
    if (lineName === "nankai") {
      kind = MasterData.nankaiTrainKindById(train.train_kind_id)
    } else {
      kind = MasterData.koyaTrainKindById(train.train_kind_id)
    }

    // 扉数
    const door_count = train.door_count > 0 ? <span className="c-Modal-carDoorCount">{train.door_count}扉</span> : ""
    const departure_station = departure_station_name ?　<span className="c-Modal-trainSectionStart">{departure_station_name}発</span> : ""
    const arrival_station = arrival_station_name ? <span className="c-Modal-trainSectionEnd">{arrival_station_name}行き</span> : ""

    return (
      <div className="c-Modal-body">
        <div className="c-Modal-trainSummary">
          <div className={`c-Modal-trainCarInfo ${kind.kind}`}>
            <span className="c-Modal-carType"><p>{kind.train_type}</p></span>
            <span className="c-Modal-carOrg">{train.train_length_id}両</span>
            {door_count}
          </div>
          <p className="c-Modal-trainSection">
          {departure_station}
          {arrival_station}
          </p>
        </div>

        <div className="c-Modal-trainState">
          現在地：
          {this.renderTrainStateCurrentLocation(train)}
          {this.renderDelay(train.delay)}
        </div>

        <div className="c-Modal-trainScheduleWrapper">
          <div className="c-Modal-trainScheduleHeader">
            <p className="c-Modal-trainScheduleHeaderCell -type-station">停車駅</p>
            <p className="c-Modal-trainScheduleHeaderCell -type-onTime">到着時刻/定刻</p>
            <p className="c-Modal-trainScheduleHeaderCell -type-estimatedTime">見込み</p>
          </div>

          <div className="c-Modal-trainScheduleBody">
            <ul className="c-Modal-trainSchedule">
              {station_infos ? station_infos.map(station_info => this.renderSchedule(station_info, train.delay)) : "情報取得中…" }
            </ul>

            {/* is-showをつけると到着済みになる */}
            <div className={`c-Modal-trainSchedule -type-arrived ${arrival}`}>
              <p>到着済み</p>
            </div>
          </div>
        </div>
      </div>
    )
  }

  // 遅延時間の表示
  renderDelay(delay) {
    if (0 < delay) {
      return (
        <p className="c-Modal-trainStateDelayTime is_late">
          {delay}分遅れ
        </p>
      )
    } else {
      // 遅延なし
      return (
        <p className="c-Modal-trainStateDelayTime">
        </p>
      )
    }
  }

  // 列車の現在地の表示
  renderTrainStateCurrentLocation(train) {
    const {
      lines,
      station_infos,
      arrival_station_name
    } = this.props
    const {
      lineName
    } = this.props.match.params

    let lineId = MasterData.lineIdByLineName(lineName)
    let stations = lines.find(l => l.line_id === lineId).stations.concat(lines.find(l => l.line_id === lineId + 2).stations)
    let onStation = stations.find(s => s.id === train.station_id)

    if (!train.next_station_id) {
      return ( 
        <p className = "c-Modal-trainStateCurrentLocation" >
          <span className = "c-Modal-trainStateLocation" > 
          {onStation.name_ja} 
          </span>
        </p>
      )
    }

    let otherStation = stations[stations.findIndex(s => s.id === onStation.id) + 1]
    return ( 
      <p className = "c-Modal-trainStateCurrentLocation" >
        <span className = "c-Modal-trainStateLocation" > 
        {train.direction === 'up' ? otherStation.name_ja : onStation.name_ja} 
        </span> 
        <span className = "c-Modal-trainStateLocation" > 
        {train.direction === 'up' ? onStation.name_ja : otherStation.name_ja} 
        </span> 
      </p >
    )
  }

  // スケジュールの表示
  renderSchedule(station_info, delay) {
    var today = new Date();
    if (station_info.arrival_time != null) {
      const arrival_time = station_info.arrival_time
      const time = station_info.arrival_time.split(":")
      today.setHours(time[0]);
      today.setMinutes(parseInt(time[1]) + delay);
      const estimated_time = ( '00' + today.getHours()).slice( -2 ) + ":" + ( '00' + today.getMinutes()).slice( -2 )

      return (
        <li key={station_info.station_name} className="c-Modal-trainScheduleRow">
          <div className="c-Modal-trainScheduleBodyItem -type-line"></div>
          <p className="c-Modal-trainScheduleBodyCell -type-station">{station_info.station_name}</p>
          <p className="c-Modal-trainScheduleBodyCell -type-onTime">{arrival_time}</p>
          <p className="c-Modal-trainScheduleBodyCell -type-estimatedTime">{estimated_time}</p>
        </li>
      )
    } else {
      // 時刻がnullの場合
      return (
        <li key={station_info.station_name} className="c-Modal-trainScheduleRow">
          <div className="c-Modal-trainScheduleBodyItem -type-line"></div>
          <p className="c-Modal-trainScheduleBodyCell -type-station">{station_info.station_name}</p>
          <p className="c-Modal-trainScheduleBodyCell -type-noTime">情報がありません</p>
        </li>
      )
    }
  }

  // フッター
  renderFooter() {
    return (
      <div className="c-Modal-footer">
        <p className="c-Modal-trainInfoNote">実際の運行状況と異なる場合があります。</p>
      </div>
    )
  }
  
  render() {
    const { lineName, trainNumber } = this.props.match.params
    const { trains } = this.props
    if (trains.length == 0) return null

    let lineId = MasterData.lineIdByLineName(lineName)
    let train = trains.find(t => t.train_number === trainNumber && t.line_id === lineId)
    if (MasterData.isShiomibashiTrain(trainNumber)) {
      // 汐見橋線の列車は南海線としてダイヤ情報を取得する
      train = trains.find(t => t.train_number === trainNumber)
    }

    if (train == "undefined") return null

    return (
      <div
        className={`c-Modal is_${lineName}`}
        onClick={ () => this.closeModal(lineName, trainNumber) }
      >
        <div
          className="c-Modal-dialog"
          onClick={(e) => e.stopPropagation()}
        >
          {this.renderHeader()}
          {this.renderTrainBody(train)}
          {this.renderFooter()}
        </div>
      </div>
    )
  }
}

export default SingleTrainModal
